import * as React from 'react';
import { components } from 'react-select';
import { Button } from "../..";
export var ClearIndicator = function ClearIndicator(props) {
  var size = props.selectProps.size;
  return size !== 'tiny' && /*#__PURE__*/React.createElement(components.ClearIndicator, props, /*#__PURE__*/React.createElement(Button, {
    appearance: "icon",
    size: "tiny",
    icon: "cross_circle"
  }));
};